import AFRAME from 'aframe'
let THREE = require('three')
import { spine } from '../utils/spine-threejs';

// TEXTURE CACHE
//const textureLoader = new THREE.TextureLoader()
//textureLoader.setCrossOrigin('')
// console.log(222, textureLoader)

let assetManager = new spine.threejs.AssetManager('')

AFRAME.registerSystem('asset-manager', {
  schema: {},
  init: function() {
    //this.assetManager = assetManager
  },
  tick: function() {},
  play: function() {},
  pause: function() {},
  loadAsset(json, atlas, tex){
    if (!assetManager.assets[json])
      assetManager.loadText(json)
    if (!assetManager.assets[atlas] || !assetManager.assets[tex.src])
      assetManager.loadTextureAtlas(atlas, tex.src)
  },
  getAssetManager(){
    return assetManager
  },

  destroyCache() {
    assetManager.dispose()
  },
})
